module.exports = __webpack_public_path__ + "img/hover_card_medicaid_certification.aca0cf33.svg";